import { FacebookEmbed } from "react-social-media-embed";
import { facebookPosts, instagramPosts } from "../somePosts";
import FacebookButton from "../Components/FacebookButton";
import InstagramButton from "../Components/InstagramButton";
import HolidayGreeter from "../Components/HolidayGreeter";
import ErrorBoundary from "../Components/ErrorBoundary";
import Visitors from "../Components/VisitorCounter";
import "./Frontpage.css";

export default function Home() {
  return (
    <div>
      <div>
        <HolidayGreeter />
      </div>
      <div className="frontpage">
        <div className="facebook">
          <ErrorBoundary
            type="Facebook"
            fallbackLink="https://www.facebook.com/profile.php?id=100092389456753"
          >
            <div>
              <FacebookEmbed
                className="facebook-bg"
                url={facebookPosts[0]}
                key={facebookPosts[0]}
              />
              <FacebookButton />
            </div>
          </ErrorBoundary>
        </div>
        <div className="instagram">
          <ErrorBoundary
            type="Instagram"
            fallbackLink="https://www.instagram.com/minebikers_mcc/"
          >
            <div>
              <iframe
                title="Instagram post"
                src={`${instagramPosts[0]}embed/`}
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
                allow="encrypted-media"
                style={{
                  border: "none",
                  overflow: "hidden",
                  width: "110%",
                  height: "80%",
                }}
              />

              {/* <InstagramEmbed
                url={instagramPosts[0]}
                captioned
                key={instagramPosts[0]}
              /> */}
              <InstagramButton />
            </div>
          </ErrorBoundary>
        </div>
      </div>
      <div className="visitor-counter">
        <Visitors />
      </div>
    </div>
  );
}
